module.exports = __webpack_public_path__ + "static/media/calendario.45df86b6.png";